import { FilterSchedulerItem } from '../models/item';

export const filtersSchedulerItem = (
  item: FilterSchedulerItem,
  valueFilter: string
): boolean => {
  return `${item.title} ${item.assemblyItem.title}`
    .toUpperCase()
    .includes(valueFilter.toUpperCase());
};
